module.exports = __webpack_public_path__ + "img/denglu.ea9004de.png";